import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Utilities } from 'src/app/shared/utilities';

@Component({
  selector: 'app-prime-multi-select',
  templateUrl: './prime-multi-select.component.html',
  styleUrls: ['./prime-multi-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PrimeMultiSelectComponent),
      multi: true,
    },
  ],
  encapsulation: ViewEncapsulation.None,
})
export class PrimeMultiSelectComponent implements ControlValueAccessor {
  @Input() options: any;
  @Input() optionLabel: string;
  @Input() showHeader: boolean;
  @Input() dataKey: string;
  @Input() maxSelectedLabels: number = 3;
  @Input() inputId: string;
  @Input() styleClass: string;
  @Input() selectedItems: Array<any>;
  @Input() filter: boolean = true;
  @Input() emptyFilterMessage: string = 'Результаты не найдены';
  @Input() defaultLabel: string = 'Выбрать';
  @Input() showClear: boolean = false;
  @Input() resetFilterOnHide: boolean = false;
  @Output() selectedValueChange = new EventEmitter();
  @Output() onClearEvent = new EventEmitter();

  private _selectedItems: Array<any> = [];

  get selectedItemsArray() {
    return this._selectedItems;
  }

  set selectedItemsArray(values) {
    this._selectedItems = values;
  }

  constructor() {
    this.dataKey = this.dataKey || 'Id';
    this.optionLabel = this.optionLabel || 'Title';
  }

  onClear() {
    this.selectedItemsArray = null;
    this.selectedValueChange.emit(this.selectedItemsArray);
    this.writeValue(this.selectedItemsArray);
    this.onClearEvent.emit();
  }

  selectionChange($event: any) {
    let outputArray = [];
    if ($event.value.length > 0) {
      outputArray = this.selectedItemsArray;
    }
    this.selectedValueChange.emit(this._selectedItems);
    this.writeValue(outputArray);
  }

  onChange: any = () => {};
  onToched: any = () => {};

  writeValue(obj: any): void {
    this.onChange(obj);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onToched = fn;
  }
  ngOnChanges() {
    if (
      !Utilities.isUndefined(this._selectedItems) &&
      this._selectedItems &&
      this._selectedItems.length === 0 &&
      !this.selectedItems
    ) {
      this.selectedItemsArray = [];
    } else {
      this.selectedItemsArray = this.selectedItems;
    }
  }
}
